
export class RoleContactModel {
    rcId: number;
    name: string;
    contact: string;

    /**
     * @param rcId
     * @param name 
     * @param contact 
     */
    constructor( rcId: number, name: string, contact: string) {
        this.rcId = rcId;
        this.name = name;
        this.contact = contact;
    }
}